export default __webpack_public_path__ + "static/media/dark-wall.4845d21a.webp";